export interface FibuFahrzeugKostenart {
    sachkonto: string;
    kostenstelle_suffix: string;
}

export interface FibuFahrzeug {
    fibu_fahrzeug_id?: number;
    kennzeichen?: string;
    bezeichnung?: string;
    fahrzeug_art?: string;
    modell?: string;
    kostenstelle_suffix?: string;
    tierarzt_id?: number;
    tierarzt?: string;
    tierarzt_titel?: string;
    tierarzt_vorname?: string;
    tierarzt_nachname?: string;
    aktiv?: number;
    kommentar?: string;
    anzeige?: string;
    kostenarten_map?: string;
    kostenarten?: FibuFahrzeugKostenart[];
}

/** Standard-Kostenarten für Dialog (Suffix je Konto pflegbar). */
export const FIBU_FAHRZEUG_DEFAULT_KOSTENARTEN: { sachkonto: string; label: string }[] = [
    { sachkonto: '4510', label: '4510 Kfz-Steuer' },
    { sachkonto: '4520', label: '4520 Kfz-Versicherung' },
    { sachkonto: '4530', label: '4530 Kfz-Betrieb' },
    { sachkonto: '4540', label: '4540 Kfz-Reparatur' },
    { sachkonto: '4580', label: '4580 Sonstige Fz / Connectivity' },
    { sachkonto: '2120', label: '2120 Kfz-Zinsen' },
];
